import { render, staticRenderFns } from "./tdSample.vue?vue&type=template&id=41f2a93e&functional=true&"
import script from "./tdSample.vue?vue&type=script&lang=ts&"
export * from "./tdSample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports